<template>
  <q-modal v-model="show_users" :content-css="{minWidth: getMinWidth, maxWidth: getMaxWidth, minHeight: '80vh'}">
        <q-modal-layout>
            <q-toolbar slot="header">
                <q-btn flat round dense @click="show_users = false" icon="fas fa-times" />
                <q-toolbar-title>
                    {{ $t('participants') }}
                </q-toolbar-title>
            </q-toolbar>

            <div class="layout">
                <q-table
                    ref="table"
                    :data="users"
                    :columns="columns_users"
                    :pagination.sync="pagination_users"
                    @request="requestEventUsers"
                    row-key="user_id"
                    :loading="loading"
                    :no-data-label="$t('no_data_avaliable')"
                    :no-results-label="$t('no_results_found')"
                    :loading-label="$t('loading_data')"
                    :rows-per-page-label="$t('items_per_page')"
                    :rows-per-page-options="[5,10,50,100]"
                    :filter=filter_users
                    binary-state-sort
                    class="q-ma-lg"
                    >

                    <template slot="top" slot-scope="props" :props="props">
                        <q-search v-model="filter_users" icon="far fa-search" :placeholder="$t('search')" :debounce="500" />

                        <div class="col" />
                    </template>

                    <q-tr slot="header" slot-scope="props" :props="props">
                        <q-th v-for="col in props.cols" :key="col.name" :props="props">
                            {{ $t(col.label) }}
                        </q-th>
                    </q-tr>

                    <template slot="body" slot-scope="props">
                        <q-tr :props="props">
                            <q-td key="full_name" :props="props">
                                {{ props.row.full_name }}
                            </q-td>

                            <q-td key="email" :props="props">
                                {{ props.row.email }}
                            </q-td>

                            <q-td key="phone" :props="props">
                                {{ props.row.phone }}
                            </q-td>

                            <q-td key="score" :props="props">
                                {{ props.row.score }}
                            </q-td>

                            <q-td key="is_present" :props="props" auto-width>
                                <q-chip small :icon="getIconStatus(props.row.is_present)" :color="getColorStatus(props.row.is_present)" class="full-width text-center">
                                    {{ $t(getTextStatus(props.row.is_present)) }}
                                </q-chip>
                            </q-td>
                        </q-tr>
                    </template>
                </q-table>
            </div>
        </q-modal-layout>
    </q-modal>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    name: 'AdminPresentialReportEventModules',

    props: ['show_event_users', 'load', 'id', 'event_id'],

    data() {
        return {
            pagination_users: {
                page: 1,
                rowsNumber: 10,
                rowsPerPage: null,
                descending: false,
                sortBy: null
            },
            columns_users: [
                {
                    name: 'full_name',
                    required: true,
                    label: 'name',
                    align: 'left',
                    field: 'full_name',
                    sortable: true,
                },
                {
                    name: 'email',
                    required: true,
                    label: 'email',
                    align: 'left',
                    field: 'email',
                    sortable: true,
                },
                {
                    name: 'phone',
                    required: true,
                    label: 'celular',
                    align: 'left',
                    field: 'phone',
                    sortable: true,
                },
                {
                    name: 'score',
                    required: true,
                    label: 'score',
                    align: 'left',
                    field: 'score',
                    sortable: true,
                },
                {
                    name: 'is_present',
                    required: true,
                    label: 'participated',
                    align: 'left',
                    field: 'is_present',
                    sortable: true,
                }
            ],
            users: [],
            filter_users: '',
            loading: false
        }
    },

    computed: {
        ...mapGetters({
            access_token: 'common/access_token',
            num_rows: 'datatable/num_rows',
        }),

        show_users: {
            get() {
                return this.show_event_users
            },
            set() {
                this.$emit('hide_event_report', '')
            }
        },

        getHeader() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
        },

        getMaxWidth() {
            if (this.$q.platform.is.mobile) return '100vw'
            else return '80vw'
        },

        getMinWidth() {
            if (!this.$q.platform.is.mobile) return '90vw'
        },
    },

    methods: {
        requestEventUsers({ pagination }) {
            this.loading = true
            this.pagination_users = pagination

            let order = pagination.descending ? '-' : ''
            let order_by = pagination.sortBy ? order + pagination.sortBy : ''

            let data = {
                "page_size": this.pagination_users.rowsPerPage,
                "page": this.pagination_users.page,
                "ordering": order_by,
                "search": this.filter_users
            }

            this.savePaginationUsers()

            this.$axios.get(`/presential/presential_events/${this.id}/reports/event_dates/${this.event_id}/participants/?${this.$qs.stringify(data)}`, this.getHeader)
            .then(response => {
                this.pagination_users.rowsNumber = response.data.count

                this.users = response.data.results ? response.data.results.map(e => ({...e})) : []
            })
            .catch(e => {
                console.log(e)
            })
            .finally(() => {
                this.loading = false
            })
        },

        getTextStatus(present) {
            if (present) return 'yes'
            else return 'no'
        },

        getColorStatus(present) {
            if (present) return 'positive'
            else return 'negative'
        },

        getIconStatus(present) {
            if (present) return 'fal fa-check'
            else return 'fal fa-times'
        },

        savePaginationUsers() {
            this.$store.dispatch('datatable/SET_NUM_ROWS', [this.pagination_users.rowsPerPage])
        },

        loadPagination() {
            this.pagination_users.rowsPerPage = this.num_rows
        }
    },

    watch: {
        load: function() {
            if (this.load) {
                this.requestEventUsers({ pagination: this.pagination_users })
            }
        },

        num_rows: {
            handler: function(newValue) {
                this.loadPagination()
            },
            deep: true
        }
    },

    mounted () {
        this.requestEventUsers({ pagination: this.pagination_users })
    },

    created() {
        this.loadPagination()
    }

}
</script>

<style>

</style>
